import { OrderType } from 'apiConnector/secondary-market/batch/model';
import { useAppSelector } from 'hooks/useAppSelector';
import { IntlKey } from 'locales';
import { FormattedMessage } from 'react-intl';
import Skeleton from 'react-loading-skeleton';
import { selectRowCountByOrderType, selectStatusByOrderType } from 'state/workspaces/secondary-market/batch/selectors';

type Props = {
  option: OrderType;
  activeOrderType: OrderType | undefined;
  handleChange: (selected: OrderType) => void;
};

export const OrderTypeItem = ({ option, activeOrderType, handleChange }: Props) => {
  const inputId = `orders-basket-product-selector-${option}`;
  const labelKey: IntlKey = `secondaryMarket.batch.orderType.${option}.label`;
  const count = useAppSelector(state => selectRowCountByOrderType(state, option));
  const status = useAppSelector(state => selectStatusByOrderType(state, option));

  return (
    <div className="form-check" key={option}>
      <input
        className="form-check-input"
        type="radio"
        value={option}
        id={inputId}
        aria-label={option}
        checked={!!activeOrderType && activeOrderType === option}
        onChange={() => handleChange(option)}
        data-e2e={inputId}
      />
      <label className="form-check-label" htmlFor={inputId} id={inputId + '-label'}>
        <FormattedMessage id={labelKey} />
        {count !== undefined && <span className="badge badge-discreet-secondary rounded-pill ms-2">{count}</span>}
        {status === 'loading' && (
          <span className="badge badge-discreet-secondary rounded-pill ms-2">
            <Skeleton width="1em" />
          </span>
        )}
      </label>
    </div>
  );
};
